module.exports = __webpack_public_path__ + "static/media/7.609d60d7.png";